module.exports = __webpack_public_path__ + "static/img/huijiao13.0295aaba.png";